export default __webpack_public_path__ + "static/albar_deckruede-cfee4f06513731b29063f1ea7851bed0.jpg";